import {
  IGroupAlerts,
  ISelectGroupState,
} from "../../../common/types/alertsTypes";
import useHandleGroupSearch from "../../../pages/deviceManagement/useHandleGroupSearch";
import { useEffect, useState, useMemo } from "react";

const useSelectGroup = (
  // isEmergencyAlert: boolean,
  onNextTab: () => void,
  onCreateAlert: () => void,
  selectGroupState: ISelectGroupState,
  setSelectGroupState: (state: ISelectGroupState) => void,
  isSelectGroupFieldEmpty: (isAnyFieldEmpty: boolean) => void
) => {
  const [selectedGroups, setSelectedGroups] = useState<IGroupAlerts[]>(
    selectGroupState?.groups || []
  );

  useEffect(() => {
    setSelectedGroups(selectGroupState?.groups || []);
  }, [selectGroupState?.groups]);

  const { handleGroupInputChange, groupSearchQuery, nodesToDisplay, searchExpandedValues = [],} = 
    useHandleGroupSearch({isEditable: false});
  const [isAnyFieldEmpty, setIsAnyFieldEmpty] = useState<boolean>(true);

  
  const handleDataFromTreeView = (selectedGroups: IGroupAlerts[]) => {
    setSelectedGroups(selectedGroups);
  };

  const handleNextButtonClick = () => {
    // isEmergencyAlert ? onCreateAlert() : 
    onNextTab();
  };

  const userExpandedValues = selectGroupState?.expanded || [];

  const expandedValues = useMemo(() => {
    if (!groupSearchQuery.trim()) {
      return userExpandedValues;
    }
    return Array.from(
      new Set([...userExpandedValues, ...searchExpandedValues])
    );
  }, [userExpandedValues, searchExpandedValues, groupSearchQuery]);

  const setExpandedValues = (newExpanded: string[]) => {
    if (!groupSearchQuery.trim()) {
      setSelectGroupState({
        ...selectGroupState,
        expanded: newExpanded,
      });
    } else {
      const newExpandedWithoutSearch = newExpanded.filter(
        (val) => !searchExpandedValues.includes(val)
      );
      setSelectGroupState({
        ...selectGroupState,
        expanded: newExpandedWithoutSearch,
      });
    }
  };

  useEffect(() => {
    if(selectedGroups.length === 0) {
      setIsAnyFieldEmpty(true)
      isSelectGroupFieldEmpty(true);
    }
    else {
      setIsAnyFieldEmpty(false);
      isSelectGroupFieldEmpty(false);
    }


  }, [selectedGroups]);

  return {
    groupSearchQuery,
    handleGroupInputChange,
    nodesToDisplay,
    handleDataFromTreeView,
    handleNextButtonClick,
    isAnyFieldEmpty,
    expandedValues,
    setExpandedValues,
    selectGroupState,
    setSelectGroupState,
  };
};

export default useSelectGroup;
